import { Component, inject, input, signal, viewChild, viewChildren } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { RidButton } from '../../components/rid-button/rid-button';
import { CompressibleCardsService } from '../../components/rid-compressable-klank-card/compressible-cards.service';
import { RidCompressableKlankCard } from '../../components/rid-compressable-klank-card/rid-compressable-klank-card';
import { RidFunctionalSyllabicKeyboard } from '../../components/rid-functional-syllabic-keyboard/rid-functional-syllabic-keyboard';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidOverlayFeedback } from '../../components/rid-overlay-feedback/rid-overlay-feedback';
import { RidSyllabicCard } from '../../components/rid-syllabic-card/rid-syllabic-card';
import { TKeyboardLayout, TKeyValue } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidTextInput } from '../../components/rid-text-input/rid-text-input';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidVerticalSpacer } from '../../components/rid-vertical-spacer/rid-vertical-spacer';
import { RidSfxDirective } from '../../directives/rid-sfx.directive';
import { IconBackspace } from '../../icons/i-backspace';
import { IconEnter } from '../../icons/i-enter';
import { PronunciationService } from '../../services/pronunciation.service';

@Component({
  selector: 'rid-syllabic-keyboard-freeform',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidFunctionalSyllabicKeyboard,
    RidTextInput,
    RidVerticalSpacer,
    RidCompressableKlankCard,
    RidSyllabicCard,
    RidButton,
    RidOverlayFeedback,
    IconBackspace,
    IconEnter,
    RidSfxDirective,
  ],
  templateUrl: './rid-syllabic-keyboard-freeform.html',
  host: {
    class: 'block',
  },
})
export class RidSyllabicKeyboardFreeform {
  private readonly $compressibleCardsService = inject(CompressibleCardsService);
  private readonly $pronunciationService = inject(PronunciationService);

  layout = input<TKeyboardLayout | undefined>();
  mode = input<'GROUP' | 'KLANK' | 'BOTH'>('BOTH');
  mask = input<TKeyValue[] | undefined>();

  keyboardComp = viewChild.required<RidFunctionalSyllabicKeyboard>('keyboardComp');

  syllabicCard = viewChildren<RidSyllabicCard>('syllabicCard');

  version = signal(0);

  isEvaluating = signal(false);

  async okay() {
    this.isEvaluating.set(true);

    const isCompressable = this.keyboardComp()
      .content()
      .every((k) => k.type === 'KLANK' || k.type === 'EXCEPTION' || k.type === 'SPACE');

    if (isCompressable) {
      const content = this.keyboardComp().getRawText();
      console.log({ content });
      await Promise.all([
        this.$compressibleCardsService.compress(this.syllabicCard().flatMap((c) => c.compressable())),
        this.$pronunciationService.tryPronounce(content),
      ]);

      await delay(500);
    }

    this.keyboardComp().clear();

    this.version.set(this.version() + 1);
    this.isEvaluating.set(false);
  }
}
